import React from 'react';
import styled from 'styled-components';

export default function Kariera() {
  return (
    <PageWrapper>
      <h1>Kariéra</h1>
      <p>Aktuálně nehledáme žádné nové kolegy.</p>
    </PageWrapper>
  );
}

const PageWrapper = styled.div`
  padding: 24px 24px 100px 24px;
  width: 100%;
  text-align: center;

  @media (max-width: 700px) {
    padding: 24px 24px 50px 24px;
  }
`;
